import { Paper } from '@mui/material';
import styled from 'styled-components';

export const Section = styled(Paper)`
  padding: 8px 16px;
  margin-bottom: 24px;
`;

export const SectionTitle = styled.div`
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 500;
`;
